import type { PostHog } from 'posthog-js';

// posthog-js (~175K) loads post-boot via dynamic import on idle — never in the
// entry chunk. Events fired before init are dropped (same semantics as the old
// __loaded guard); identify is single-slot replayed so the boot-time
// authProvider identify survives the deferred init.
let posthogClient: PostHog | null = null;
let initScheduled = false;
let pendingIdentify: { userId: string; properties?: Record<string, any> } | null = null;

export const initAnalytics = (apiKey: string, options: Record<string, any>) => {
  if (initScheduled) return;
  initScheduled = true;
  const start = () => {
    import('posthog-js')
      .then(({ default: posthog }) => {
        posthog.init(apiKey, options);
        posthogClient = posthog;
        if (pendingIdentify) {
          identifyUser(pendingIdentify.userId, pendingIdentify.properties);
          pendingIdentify = null;
        }
      })
      .catch(() => {
        // analytics is best-effort — a failed load must never surface
      });
  };
  if (typeof window.requestIdleCallback === 'function') {
    window.requestIdleCallback(start, { timeout: 4000 });
  } else {
    window.setTimeout(start, 2000);
  }
};

export const trackEvent = (event: string, properties?: Record<string, any>) => {
  if (posthogClient?.__loaded) {
    posthogClient.capture(event, properties);
  }
};

export const identifyUser = (userId: string, properties?: Record<string, any>) => {
  if (posthogClient?.__loaded) {
    posthogClient.identify(userId, properties);
  } else {
    pendingIdentify = { userId, properties };
  }
};
